<template>
    <modal v-if="showModal" class="account-modal" @close="actionHideModal">
        <template slot="header">
            <div class="modal-title-container">
                <h4 class="modal-title">{{$t('Do you have an account to pair?')}}</h4>
                <div class="icon-container">
                    <md-icon @click.native="actionHideModal">{{$t('clear')}}</md-icon>
                </div>
            </div>
            <p>{{$t('Log in with your details to pair the account.')}}</p>
        </template>
        <template slot="body">
            <md-field>
                <label>{{$t('Username')}}</label>
                <md-input v-model="username" type="text"></md-input>
            </md-field>
            <md-field>
                <label>{{$t('Password')}}</label>
                <md-input v-model="password" type="password"></md-input>
            </md-field>
        </template>
        <template slot="footer">
            <md-button class="md-simple" @click="actionHideModal">{{$t('Cancel')}}</md-button>
            <md-button class="md-primary" @click="actionPairAccount">{{$t('Pair account')}}</md-button>
        </template>
    </modal>
</template>

<script>
    import Modal from "../components/Modal";

    export default {
        name: "AccountPairModal",
        props: {
            showModal: {
                type: Boolean,
                required: true,
            }
        },
        components: {Modal},
        computed: {
            platformSlug() {
                return this.$parent.slug ?? '';
            }
        },
        data() {
            return {
                username: '',
                password: '',
            }
        },
        methods: {
            actionHideModal() {
                this.$parent.showModal = false;
            },
            actionPairAccount() {
                this.$api.pairAccount({
                    data: {
                        username: this.username,
                        password: this.password,
                        platformSlug: this.platformSlug
                    }
                }).then(() => {
                    this.$bus.emit('init');
                    this.actionHideModal();
                });
            }
        },
    }
</script>

<style lang="scss">
    .account-modal {
        .modal-header {
            flex-direction: column;
            align-items: flex-start;

            .modal-title-container {
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
            }

            .icon-container {
                .md-icon {
                    opacity: .5;
                    font-size: 16px !important;
                    cursor: pointer;

                    &:hover {
                        opacity: 1;
                    }
                }
            }
        }

        .modal-footer {
            & > * {
                margin-left: 12px !important;
            }
        }

        .modal-header, .modal-body, .modal-footer {
            width: 500px;
        }

        .md-table-cell {
            padding: 0;
        }
    }
</style>